// 主要都道府県の市区町村データ（抜粋）
export const CITIES_BY_PREFECTURE = {
  '東京都': [
    '千代田区', '中央区', '港区', '新宿区', '文京区', '台東区', '墨田区', '江東区',
    '品川区', '目黒区', '大田区', '世田谷区', '渋谷区', '中野区', '杉並区', '豊島区',
    '北区', '荒川区', '板橋区', '練馬区', '足立区', '葛飾区', '江戸川区',
    '八王子市', '立川市', '武蔵野市', '三鷹市', '青梅市', '府中市', '昭島市', '調布市',
    '町田市', '小金井市', '小平市', '日野市', '東村山市', '国分寺市', '国立市',
    '福生市', '狛江市', '東大和市', '清瀬市', '東久留米市', '武蔵村山市', '多摩市',
    '稲城市', '羽村市', 'あきる野市', '西東京市'
  ],
  '神奈川県': [
    '横浜市鶴見区', '横浜市神奈川区', '横浜市西区', '横浜市中区', '横浜市南区',
    '横浜市保土ケ谷区', '横浜市磯子区', '横浜市金沢区', '横浜市港北区', '横浜市戸塚区',
    '横浜市港南区', '横浜市旭区', '横浜市緑区', '横浜市瀬谷区', '横浜市栄区',
    '横浜市泉区', '横浜市青葉区', '横浜市都筑区',
    '川崎市川崎区', '川崎市幸区', '川崎市中原区', '川崎市高津区', '川崎市多摩区',
    '川崎市宮前区', '川崎市麻生区',
    '相模原市緑区', '相模原市中央区', '相模原市南区',
    '横須賀市', '平塚市', '鎌倉市', '藤沢市', '小田原市', '茅ヶ崎市', '逗子市',
    '三浦市', '秦野市', '厚木市', '大和市', '伊勢原市', '海老名市', '座間市',
    '南足柄市', '綾瀬市'
  ],
  '大阪府': [
    '大阪市都島区', '大阪市福島区', '大阪市此花区', '大阪市西区', '大阪市港区',
    '大阪市大正区', '大阪市天王寺区', '大阪市浪速区', '大阪市西淀川区', '大阪市東淀川区',
    '大阪市東成区', '大阪市生野区', '大阪市旭区', '大阪市城東区', '大阪市阿倍野区',
    '大阪市住吉区', '大阪市東住吉区', '大阪市西成区', '大阪市淀川区', '大阪市鶴見区',
    '大阪市住之江区', '大阪市平野区', '大阪市北区', '大阪市中央区',
    '堺市堺区', '堺市中区', '堺市東区', '堺市西区', '堺市南区', '堺市北区', '堺市美原区',
    '岸和田市', '豊中市', '池田市', '吹田市', '泉大津市', '高槻市', '貝塚市',
    '守口市', '枚方市', '茨木市', '八尾市', '泉佐野市', '富田林市', '寝屋川市',
    '河内長野市', '松原市', '大東市', '和泉市', '箕面市', '柏原市', '羽曳野市',
    '門真市', '摂津市', '高石市', '藤井寺市', '東大阪市', '泉南市', '四條畷市',
    '交野市', '大阪狭山市', '阪南市'
  ],
  '愛知県': [
    '名古屋市千種区', '名古屋市東区', '名古屋市北区', '名古屋市西区', '名古屋市中村区',
    '名古屋市中区', '名古屋市昭和区', '名古屋市瑞穂区', '名古屋市熱田区', '名古屋市中川区',
    '名古屋市港区', '名古屋市南区', '名古屋市守山区', '名古屋市緑区', '名古屋市名東区',
    '名古屋市天白区',
    '豊橋市', '岡崎市', '一宮市', '瀬戸市', '半田市', '春日井市', '豊川市', '津島市',
    '碧南市', '刈谷市', '豊田市', '安城市', '西尾市', '蒲郡市', '犬山市', '常滑市',
    '江南市', '小牧市', '稲沢市', '新城市', '東海市', '大府市', '知多市', '知立市',
    '尾張旭市', '高浜市', '岩倉市', '豊明市', '日進市', '田原市', '愛西市', '清須市',
    '北名古屋市', '弥富市', 'みよし市', 'あま市', '長久手市'
  ],
  '福岡県': [
    '福岡市東区', '福岡市博多区', '福岡市中央区', '福岡市南区', '福岡市西区',
    '福岡市城南区', '福岡市早良区',
    '北九州市門司区', '北九州市若松区', '北九州市戸畑区', '北九州市小倉北区',
    '北九州市小倉南区', '北九州市八幡東区', '北九州市八幡西区',
    '大牟田市', '久留米市', '直方市', '飯塚市', '田川市', '柳川市', '八女市',
    '筑後市', '大川市', '行橋市', '豊前市', '中間市', '小郡市', '筑紫野市',
    '春日市', '大野城市', '宗像市', '太宰府市', '古賀市', '福津市', 'うきは市',
    '宮若市', '嘉麻市', '朝倉市', 'みやま市', '糸島市'
  ],
  '北海道': [
    '札幌市中央区', '札幌市北区', '札幌市東区', '札幌市白石区', '札幌市豊平区',
    '札幌市南区', '札幌市西区', '札幌市厚別区', '札幌市手稲区', '札幌市清田区',
    '函館市', '小樽市', '旭川市', '室蘭市', '釧路市', '帯広市', '北見市', '夕張市',
    '岩見沢市', '網走市', '留萌市', '苫小牧市', '稚内市', '美唄市', '芦別市',
    '江別市', '赤平市', '紋別市', '士別市', '名寄市', '三笠市', '根室市',
    '千歳市', '滝川市', '砂川市', '歌志内市', '深川市', '富良野市', '登別市',
    '恵庭市', '伊達市', '北広島市', '石狩市', '北斗市'
  ]
};

// その他の都道府県は主要市のみ
export const OTHER_PREFECTURES_CITIES = {
  '青森県': ['青森市', '弘前市', '八戸市', '黒石市', '五所川原市', '十和田市', '三沢市', 'むつ市', 'つがる市', '平川市'],
  '岩手県': ['盛岡市', '宮古市', '大船渡市', '花巻市', '北上市', '久慈市', '遠野市', '一関市', '陸前高田市', '釜石市'],
  '宮城県': ['仙台市青葉区', '仙台市宮城野区', '仙台市若林区', '仙台市太白区', '仙台市泉区', '石巻市', '塩竈市', '気仙沼市', '白石市', '名取市'],
  '埼玉県': ['さいたま市西区', 'さいたま市北区', 'さいたま市大宮区', 'さいたま市見沼区', 'さいたま市中央区', 'さいたま市桜区', 'さいたま市浦和区', 'さいたま市南区', 'さいたま市緑区', 'さいたま市岩槻区', '川越市', '熊谷市', '川口市', '行田市', '秩父市', '所沢市', '飯能市', '加須市', '本庄市', '東松山市'],
  '千葉県': ['千葉市中央区', '千葉市花見川区', '千葉市稲毛区', '千葉市若葉区', '千葉市緑区', '千葉市美浜区', '銚子市', '市川市', '船橋市', '館山市', '木更津市', '松戸市', '野田市', '茂原市', '成田市', '佐倉市', '東金市', '旭市', '習志野市', '柏市'],
  '京都府': ['京都市北区', '京都市上京区', '京都市左京区', '京都市中京区', '京都市東山区', '京都市下京区', '京都市南区', '京都市右京区', '京都市伏見区', '京都市山科区', '京都市西京区', '福知山市', '舞鶴市', '綾部市', '宇治市', '宮津市', '亀岡市', '城陽市', '向日市', '長岡京市'],
  '兵庫県': ['神戸市東灘区', '神戸市灘区', '神戸市兵庫区', '神戸市長田区', '神戸市須磨区', '神戸市垂水区', '神戸市北区', '神戸市中央区', '神戸市西区', '姫路市', '尼崎市', '明石市', '西宮市', '洲本市', '芦屋市', '伊丹市', '相生市', '豊岡市', '加古川市', '赤穂市']
};

// 都道府県に対応する市区町村を取得
export const getCitiesByPrefecture = (prefecture) => {
  if (CITIES_BY_PREFECTURE[prefecture]) {
    return CITIES_BY_PREFECTURE[prefecture];
  }
  if (OTHER_PREFECTURES_CITIES[prefecture]) {
    return OTHER_PREFECTURES_CITIES[prefecture];
  }
  return ['市区町村を選択してください'];
};

// すべての市区町村を取得
export const getAllCities = () => {
  const allCities = [];
  Object.values(CITIES_BY_PREFECTURE).forEach(cities => {
    allCities.push(...cities);
  });
  Object.values(OTHER_PREFECTURES_CITIES).forEach(cities => {
    allCities.push(...cities);
  });
  return allCities;
};